import { render, staticRenderFns } from "./practiceAdult.vue?vue&type=template&id=1d99a270&scoped=true"
import script from "./practiceAdult.vue?vue&type=script&lang=js"
export * from "./practiceAdult.vue?vue&type=script&lang=js"
import style0 from "./practiceAdult.vue?vue&type=style&index=0&id=1d99a270&lang=scss"
import style1 from "./practiceAdult.vue?vue&type=style&index=1&id=1d99a270&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d99a270",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d99a270')) {
      api.createRecord('1d99a270', component.options)
    } else {
      api.reload('1d99a270', component.options)
    }
    module.hot.accept("./practiceAdult.vue?vue&type=template&id=1d99a270&scoped=true", function () {
      api.rerender('1d99a270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/practice/practiceAdult.vue"
export default component.exports